<script>
import { Bar } from 'vue-chartjs'

export default {
    extends: Bar,
    props: ['chartdata'],
    data() {
        return {
            options: {
                title: {
                    display: true,
                    text: 'Correctly Recalled Letters',
                    fontSize: 20
                },
                legend: {
                    display: false
                },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'No. of Letters'
                        }
                    }],
                    yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Correctly Recalled'
                        },
                        ticks: {
                            suggestedMax: 100,
                            suggestedMin: 0
                        }
                    }]
                }
            }
        }
    },
    mounted() {
        this.renderChart(this.chartdata, this.options)
    }
}
</script>